export const getIsDemoHost = () => {
  try {
    const demoDomin = process.env.REACT_APP_DEMO_DOMAIN;
    const currentDomain = window.location.hostname;
    if (demoDomin === currentDomain) {
      return true
    }
  } catch (error) {
    console.log('unable to check domain host ', error)
  }

  return false;
}